import { Lock } from "lucide-react";
import Constellation from "@/components/Constellation";

const SIGNS = ["Aries", "Taurus", "Gemini", "Cancer", "Leo", "Virgo",
  "Libra", "Scorpio", "Sagittarius", "Capricorn", "Aquarius", "Pisces"];

export function SignGrid({ onPick, locked, className = "" }) {
  return (
    <div className={`grid grid-cols-3 gap-3 ${className}`}>
      {SIGNS.map((s) => (
        <button
          key={s}
          data-testid={`sign-tile-${s.toLowerCase()}`}
          onClick={() => onPick(s)}
          className="relative overflow-hidden flex flex-col items-center bg-[#0F1523] border border-[#D4AF37]/20 hover:border-[#D4AF37]/50 rounded-2xl py-3 transition-colors"
        >
          {locked && <Lock size={12} className="absolute top-2 right-2 text-[#A7B0C0]" />}
          <Constellation sign={s} size={56} />
          <span className="text-sm text-[#E8DCC4] mt-1">{s}</span>
        </button>
      ))}
    </div>
  );
}

export function ModeToggle({ mode, setMode, weeklyLocked }) {
  return (
    <div className="flex bg-[#0B0F19]/80 border border-[#D4AF37]/25 rounded-full p-1 mb-5" data-testid="signs-mode-toggle">
      {[["daily", "Today"], ["weekly", "This Week"], ["monthly", "This Month"]].map(([k, label]) => (
        <button
          key={k}
          data-testid={`signs-mode-${k}`}
          onClick={() => setMode(k)}
          className={`flex-1 py-2 rounded-full text-sm transition-colors ${
            mode === k ? "bg-[#D4AF37] text-[#04060B]" : "text-[#A7B0C0] hover:text-[#E8DCC4]"
          }`}
        >
          {label}
          {k !== "daily" && weeklyLocked && <Lock size={11} className="inline ml-1 -mt-0.5" />}
        </button>
      ))}
    </div>
  );
}

